





















































import { Component, Vue } from "vue-property-decorator";

@Component
export default class StickyHeader extends Vue {
    sticky: boolean = false;

    mounted() {
        const self = this;

        let last_known_scroll_position = 0;
        let ticking = false;
        let body = document.body,
            html = document.documentElement;

        const vh = Math.max(
            document.documentElement.clientHeight || 0,
            window.innerHeight || 0
        );

        window.addEventListener("scroll", function(e) {
            last_known_scroll_position = window.scrollY;

            let height = Math.max(
                body.scrollHeight,
                body.offsetHeight,
                html.clientHeight,
                html.scrollHeight,
                html.offsetHeight
            );

            if (!ticking) {
                window.requestAnimationFrame(function() {
                    if (last_known_scroll_position > 50) {
                        self.sticky = true;
                    } else {
                        self.sticky = false;
                    }

                    ticking = false;
                });

                ticking = true;
            }
        });
    }
}
